const validateHtml = (html) => html;

const allowedDomains = [
  'magateway-dev.pwc.com',
  'magateway-stg.pwc.com',
  'magateway-preprod.pwc.com',
  'magateway.pwc.com',
  'localhost:3000',
];

const validateFileLink = (link) => {
  ///project/subsidiary/${projectId}/report?type=${type}
  if (isValidUrl(link)) {
    const url = new URL(link);
    if (!allowedDomains.includes(url.hostname)) {
      return false;
    }
  }
  return true;
};

const isValidUrl = (url) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i',
  );

  return pattern.test(url);
};

export { validateHtml, validateFileLink };
